import classes from "./CardHolder.module.css"
import React, { memo } from "react";
import ExpandCard from "../ExpandCard/ExpandCard";
import CardContents from "../CardContents/CardContents"
import Card from "../Card/Card";
import { useState } from "react";
import { useStateContext } from '../../context/StateContext';

// console.log(species)

const CardHolder = ({ title, taxonName, sortMethod, month }) => {

  const { searchTerm, allSpeciesData } = useStateContext()
  const [showMore, setShowMore] = useState(false);


  let visibleCardsLimit = showMore ? 1000 : 5
  const handleShowMoreClick = () => {
    // console.log(showMore)
    setShowMore((prev) => !prev)
  }

  const sortByRelated = (a, b) => {
    const x = a.taxon.ancestor_ids
    const y = b.taxon.ancestor_ids
    for (let i = 0; i < x.length; i++) {
      if (x[i] !== y[i]) {
        return x[i] - y[i]
      }
    }
  }

  const sortByCommon = (a, b) => { return b.count - a.count }

  const sortFunction = (a, b) => {
    if (sortMethod === 'common') return sortByCommon(a, b)
    if (sortMethod === 'related') return sortByRelated(a, b)
  }

  const taxonSpecies = allSpeciesData
    .filter(x => x.taxon.iconic_taxon_name === taxonName)

  const filteredSpecies = taxonSpecies
    .filter(x => x.month === month)
    .filter(x => {
      return (
        x.taxon?.preferred_common_name?.toLowerCase().includes(searchTerm?.toLowerCase()) |
        x.taxon?.name?.toLowerCase().includes(searchTerm?.toLowerCase())
      )
    }
    )
    .sort(sortFunction)

  let taxaShowMore = !showMore
  let taxaShowLess = showMore

  let holderTitle = ''
  if (allSpeciesData.length === 0 & taxonName === 'Plants') {
    holderTitle = <img src='/img/loading.gif' alt="Loading species..." />
  }

  if (filteredSpecies.length > 0) {
    holderTitle = title
  }

  if (filteredSpecies.length < 6) {
    taxaShowMore = false
    taxaShowLess = false
  }

  const CardList = memo(() => {
    return (
      <>
        {/* {console.log(species)} */}
        {
          filteredSpecies
            .filter((x, i) => i < visibleCardsLimit)
            .map((speciesInfo, i) => {
              return (
                <Card key={speciesInfo.taxon.name}>
                  <CardContents
                    key={speciesInfo.taxon.name}
                    speciesInfo={speciesInfo}
                  />
                </Card>
              )
            })
        }
      </>
    )
  })

  if(filteredSpecies.length === 0 ) return (null)

  return (
    <div className={classes.cardholder}>
      <div className={classes.holdertitle}>{holderTitle}</div>
      <div className={classes.cards}>
        {taxaShowLess && <ExpandCard show={showMore} handleShowMoreClick={() => handleShowMoreClick(taxonName)} />}
        <CardList />
        {taxaShowMore && <ExpandCard show={showMore} handleShowMoreClick={() => handleShowMoreClick(taxonName)} />}
      </div>
    </div>
  )
}

export default CardHolder